import { useState ,useEffect} from 'react'
import './Network.css'

export default function Network({phone, balans, operator_name}) {

    const [networkInfo, setNetworkInfo] = useState({
        phone: '...',
        operator_name: '...',
        balans: '...',
        isMinBalans: false,
      });

    useEffect(() => {
        setNetworkInfo({
          phone: phone || '...',
          operator_name: operator_name || '...',
          balans: balans || '...',
          isMinBalans: balans ? (balans<= 50 ? (true) : (false)) : (false),
        });
      }, [phone, balans, operator_name]);

    return(
        <div className="NetworkCard">
            <div className='NetworkCardHeader'> 
                <h4>Сеть</h4>
            </div>
            <div className="NetworkOperator">
                <span>Оператор: 
                    <span>{networkInfo.operator_name==="default" ? '...' : networkInfo.operator_name}</span>
                    </span>
            </div>
            
            <div className="Balanse">
                <span>Баланс: <span className={networkInfo.isMinBalans && "BalanceMin"}>{networkInfo.balans+'р '}</span>
                {networkInfo.isMinBalans && 
                <span className="BalanceMin">Внимание!</span>}
                </span>
            </div>
            <div className="NamberFone">
                <span>Номер sim-карты: {networkInfo.phone && networkInfo.phone.length > 0 && networkInfo.phone[0]==='9' ? (8+networkInfo.phone) : ('...')}
                </span>
            </div>


        </div>
    )
}